import PageTitle from "../ui/PageTitle";
import { useLoaderData } from "react-router-dom";
import { EventForm } from "./EventForm";

const UpdateEvent = () => {
  const { event } = useLoaderData();
  return (
    <>
      <div className="page-div">
        <div className="title-area w-full">
          <PageTitle
            title="Update Event"
            breadcrumb={[
              { name: "home", path: "/" },
              { name: "event", path: "/event" },
              { name: "update", path: `/event/update/${event.eventEntityId}` },
            ]}
          />
        </div>
        <EventForm event={event} />
      </div>
    </>
  );
};

export default UpdateEvent;
